import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { TextField, TextFieldProps } from '../text-field';
import { formatCardNumber, getCardNumberParser } from './transform';

type PrepaidCardNumberFieldProps = TextFieldProps & {
  cardNumberLength?: number;
};

export const PrepaidCardNumberField = (props: PrepaidCardNumberFieldProps) => {
  const { cardNumberLength = 16, inputProps, fieldProps, ...restProps } = props;

  const intl = useIntl();

  const parse = useMemo(() => getCardNumberParser(cardNumberLength), [cardNumberLength]);

  return (
    <TextField
      autoComplete="on"
      inputProps={{
        ...inputProps,
        inputMode: 'numeric',
        autoComplete: 'on',
        autocompletetype: 'cc-number',
        pattern: '\\d*',
      }}
      fieldProps={{
        ...fieldProps,
        format: formatCardNumber,
        parse,
      }}
      label={intl.formatMessage({
        id: 'payments:prepaid:card-number-field-label',
        defaultMessage: 'Card Number',
        description: 'Card Number field label',
      })}
      {...restProps}
    />
  );
};
